import React from 'react';
import styled from 'styled-components';
import { min } from 'js-media-query';

import Button from '../Button';
import ContainerModal from '../ContainerModal';
import { Unit } from '../ServiceItem';
import { unitWorkDaysString } from '../../utils/dates';
import { capitalize } from '../../utils/formatters';
import { ReactComponent as WarningModal } from '../../assets/warningModal.svg';

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;

  & .title {
    font-weight: 500;
    font-size: 24px;
    color: var(--color-gray-500);
    line-height: 32px;
    text-align: center;
    width: 308px;
  }

  & .subtitle {
    font-weight: 500;
    font-size: 16px;
    color: var(--color-gray-400);
    line-height: 24px;
    text-align: center;
  }

  & .date {
    font-weight: 600;
    font-size: 16px;
    color: var(--color-gray-500);
    line-height: 24px;
    text-align: left;
    width: 100%;
  }

  & .link {
    font-weight: 600;
    font-size: 16px;
    color: var(--blue-einstein);
    line-height: 24px;
    padding-top: 8px;
  }

  img {
    width: 120px;
    height: 120px;
  }
`;

const Center = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

type ModalScheduleNotNecessaryProps = {
  visible: boolean;
  onClickClose: () => void;
  unit: Unit | undefined;
};

export const ModalScheduleNotNecessary: React.FC<ModalScheduleNotNecessaryProps> = ({
  visible,
  onClickClose,
  unit
}) => {
  const [openingHours, setOpeningHours] = React.useState(['']);
  React.useEffect(() => {
    if (unit) setOpeningHours(unitWorkDaysString(unit));
  }, [unit]);
  return (
    <ContainerModal
      visible={visible}
      onClose={onClickClose}
      withoutCloseButton
      childrenFooter={
        <Button disabled={!visible} type="button" title={min(900) ? 'Voltar' : 'Fechar'} onClick={onClickClose} />
      }
    >
      <InfoContainer>
        <Center>
          <WarningModal />
          <h3 className="title">Você não precisa agendar nessa unidade</h3>
          {unit && (
            <p className="subtitle">
              O atendimento presencial na {`${capitalize(unit.name)}`} é por ordem de chegada.
              <p>Abaixo o horário de funcionamento:</p>
            </p>
          )}
          <p className="date">
            {`${openingHours.length > 0 && openingHours[0]}`}
            {openingHours.length > 1 &&
              openingHours.slice(1, openingHours.length).map((text, index) => (
                <span key={index}>
                  <br />
                  {text}
                </span>
              ))}
          </p>
          <a
            className="link"
            href="https://www.einstein.br/estrutura/centro-imunizacao/vacinas-disponiveis-no-einstein"
            target="_blank"
            rel="noreferrer"
          >
            Consulte aqui a disponibilidade da vacina nas nossas unidades
          </a>
        </Center>
      </InfoContainer>
    </ContainerModal>
  );
};
